export default [
	{
		id: "none",
		name: "resources.bookmakers.sync_status.none",
	},
	{
		id: "processing",
		name: "resources.bookmakers.sync_status.processing",
	},
	{
		id: "success",
		name: "resources.bookmakers.sync_status.success",
	},
	{
		id: "success_with_errors",
		name: "resources.bookmakers.sync_status.success_with_errors",
	},
	{
		id: "error",
		name: "resources.bookmakers.sync_status.error",
	},
];
